import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { fetchAdminStatus } from "../../../../store/slices/Citizenship/adminSlice";
import BreadCrumbs from '../../../../components/common/BreadCrumbs/BreadCrumbs';
import Dropdown from "../../../../components/common/AdminDropdown";
import { trackButtonClick, trackSearch, trackNavigation } from '../../../../services/analytics';

interface SearchStatusProps {
  selectedStatus: string;
  onStatusChange: (status: string) => void;
  onViewResults: () => void;
}

const SearchStatus = ({ selectedStatus, onStatusChange, onViewResults }: SearchStatusProps) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { status } = useAppSelector((state) => state.admin);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    dispatch(fetchAdminStatus());
  }, [dispatch]);

  // Clear error when user selects a valid status
  useEffect(() => {
    if (selectedStatus && selectedStatus !== 'Choose status') {
      setShowError(false);
    }
  }, [selectedStatus]);

  const handleViewResults = () => {
    if (selectedStatus === 'Choose status' || !selectedStatus) {
      setShowError(true);
      return;
    }
    setShowError(false);
    console.log(`📊 Analytics: View results clicked - Status: ${selectedStatus}`);
    trackButtonClick('View results', 'citizenship-search', { status: selectedStatus });
    trackSearch('citizenship-status', selectedStatus, 0);
    onViewResults();
  };

  const handlePreviousClick = () => {
    console.log('📊 Analytics: Navigate back to admin');
    trackNavigation('citizenship-reimbursement', 'admin', 'back');
    navigate("/admin")
  }
  return (
    <div className="lg:mx-40! mx-5!">
      <BreadCrumbs
        previousPage="Workplace development"
        currentPage="Citizenship reimbursement"
        onPreviousClick={handlePreviousClick}
      />
      <h1 className="h1 mt-8!">Citizenship reimbursement</h1>
      <p className="p3 -book">Manage and track reimbursement applications</p>
      <div className="margin-top-4u margin-bottom-2u bg-[#F2F8FB] w-[713px]! min-h-[12rem]!">
        <h2 className="h2 pl-4!  pt-4!">Search criteria</h2>
        <p className="p3 -book ml-4!">
          Choose a status category to display and manage application
        </p>
        <div className="flex flex-col gap-2 px-4 pb-4">
          <div className="flex items-end gap-2">
            <Dropdown
              label="Choose a status to view"
              selectedValue={selectedStatus}
              options={status}
              onSelect={onStatusChange}
              className="ml-4!"
              btnClassName={`min-w-[15rem] text-left`}
            />
            <button 
              type="button"
              className="button -primary -inverted min-w-[180px]!"
              data-analytics-type="button"
              data-analytics-click="View results"
              onClick={handleViewResults}
            >
              View results
            </button>
          </div>
          {showError && (
            <div className="flex items-start gap-2 !ml-4 mt-2" role="alert">
              <img
                src="/assets/images/errorCircleSmall.svg"
                alt=""
                aria-hidden="true"
                className="mt-0.5"
              />
              <span className="text-sm text-[#D00000]" style={{fontSize:'12px'}}>
                There are no Search Criteria for Search.
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchStatus;